import { Injectable } from '@angular/core';
import { OrderApiService } from './order.api.service';
import { Observable, Subject } from 'rxjs';
import { dataToCurrentOrder, dataToLiveOrders, dataToOrderShop } from '../dto/order.dto';
import { CurrentOrder, CurrentOrderLocation, LiveOrders } from '../models/live-order.model';
import { ItemStatus } from '../enums/item.enum';
import { WebSocketService } from './web-socket.service';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CurrentOrdersService {
  private currentRestaurant: Subject<CurrentOrderLocation> = new Subject<CurrentOrderLocation>();
  private currentOrders: Subject<LiveOrders> = new Subject<LiveOrders>();
  private staticOrders: LiveOrders = new LiveOrders();

  constructor(
    private orderApi: OrderApiService,
    private socketService: WebSocketService,
    private http: HttpClient
  ) {
  }

  public getCurrentOrders(): Observable<LiveOrders> {
    return this.currentOrders.asObservable();
  }

  public setCurrentOrders(orders: LiveOrders): void {
    this.currentOrders.next(orders);
    this.staticOrders = orders;
  }

  public getLocation(): Observable<CurrentOrderLocation> {
    return this.currentRestaurant.asObservable();
  }
  public setLocation(location: CurrentOrderLocation): void {
    this.currentRestaurant.next(location);
  }

  public getRestaurant(locationId: string): Observable<CurrentOrderLocation> {
    const apiURL = environment.apiUrl;
    return this.http.get(`${apiURL}venues/${locationId}`).pipe(map(location => {
      const current = dataToOrderShop(location);
      this.setLocation(current);
      return current;
    }));
  }

  public getOrders(locationId: string): void {
    this.orderApi.get(`api/locations/${locationId}/current-orders`).subscribe(data => {
      this.setCurrentOrders(dataToLiveOrders(data));
    });
  }

  public getGroupOrders(groupId: string): void {
    this.orderApi.get(`api/groups/${groupId}/current-orders`).subscribe(data => {
      this.setCurrentOrders(dataToLiveOrders(data));
    });
  }

  public subscribeSocket(): void {
    this.socketService.receiveOrder().subscribe((order: string) => {
     this.updateOrders(order);
    });
  }

  public subscribeGroupSocket(): void {
    this.socketService.receiveGroupOrder().subscribe((order: string) => {
      this.updateOrders(order);
    });
  }

  public updateOrders(newOrder: any): void {
    const order = dataToCurrentOrder(newOrder);
    switch (order.state) {
      case ItemStatus.reserved: return this.updateReserved(order);
      case ItemStatus.prepared: return  this.updatePrepared(order);
      case ItemStatus.completed: return this.updateCompleted(order);
    }
  }

  private updateReserved(order: CurrentOrder): void {
    if (!this.staticOrders.reserved.some(res => res.id === order.id)) {
      this.staticOrders.reserved.push(order);
      this.setCurrentOrders(this.staticOrders);
    }
  }

  private updatePrepared(order: CurrentOrder): void {
    this.staticOrders.reserved.map((reserved, index) => {
      if (reserved.id === order.id) {
        this.staticOrders.reserved.splice(index, 1);
        this.staticOrders.prepared.push(order);
        return;
      }
    });
    if (!this.staticOrders.prepared.some(res => res.id === order.id)) {
      this.staticOrders.prepared.push(order);
    }
  this.setCurrentOrders(this.staticOrders);
  }
  private updateCompleted(order: CurrentOrder): void {
    this.staticOrders.prepared.map((prepared, index) => {
      if (prepared.id === order.id) {
        this.staticOrders.prepared.splice(index, 1);
      }
    });
    this.staticOrders.reserved.map((prepared, index) => {
      if (prepared.id === order.id) {
        this.staticOrders.reserved.splice(index, 1);
      }
    });
    this.setCurrentOrders(this.staticOrders);
  }
}
